const googleDrivePdfHelper = {
    rule: 'https://drive.google.com/file/d/$d$/preview',
    get: str => str.slice(str.split('/', 5).join('"').length + 1, str.split('/', 6).join('"').length)
}
const flipHtmlHelper = {
    rule: 'https://online.fliphtml5.com/cqrrc/$d$/#p=1',
    get: str => str.slice(str.split('/', 4).join('"').length + 1, str.split('/', 5).join('"').length)
}

export default {
    WA_ME: {
        desc: 'קישור לוואטסאפ',
        rule: `https://wa.me/$d$`,
        get: str => str.slice(str.split('/', 3).join('"').length + 1)
    },
    AGREEMENT_PDF: {
        desc: 'תנאי שירות ומדיניות פרטיות',
        rule: googleDrivePdfHelper.rule,
        get: googleDrivePdfHelper.get
    },
    YOUTUBE_HERO_SECTION: {
        desc: 'סרטון הדרכה באתר',
        rule: 'https://www.youtube.com/embed/$d$',
        get: str => str.slice(str.split('/', 4).join('"').length + 1)
    },
    YOTUBE_PAGE: {
        desc: 'קישור לערוץ היוטיוב',
        rule: 'https://www.youtube.com/channel/$d$',
        get: str => str.slice(str.split('/', 4).join('"').length + 1)
    },
    AGENT_INVITATION: {
        desc: 'טופס ה',
        isLocalSaveNeeded: true
    },
    // AGENT_AGREEMENT_PDF: {
    //     desc: 'טופס הזמנת לקוח בתוך המערכת ע"י סוכן',
    //     rule: googleDrivePdfHelper.rule,
    //     get: googleDrivePdfHelper.get,
    //     isLocalSaveNeeded: true
    // },
    AGENT_TOS: {
        desc: 'תנאי שימוש מפיץ',
        rule: googleDrivePdfHelper.rule,
        get: googleDrivePdfHelper.get,
        isLocalSaveNeeded: true
    },
    INSURANCE_AGENT_TOS: {
        desc: 'תנאי שימוש סוכן ביטוח',
        rule: googleDrivePdfHelper.rule,
        get: googleDrivePdfHelper.get,
        isLocalSaveNeeded: true
    },
    ATTORNEY: {
        desc: 'ייפוי כוח',
        rule: googleDrivePdfHelper.rule,
        get: googleDrivePdfHelper.get,
        isLocalSaveNeeded: true
    },
    KEFEL_HESER: {
        desc: 'כפל חסר לדוגמא',
        rule: googleDrivePdfHelper.rule,
        get: googleDrivePdfHelper.get
    },
    MEDIWHO_PLUS: {
        desc: 'מדיהו פלוס לדוגמא',
        rule: flipHtmlHelper.rule,
        get: flipHtmlHelper.get
    },
    SUBSCRIPTION: {
        desc: 'מנויים לדוגמא',
        rule: flipHtmlHelper.rule,
        get: flipHtmlHelper.get
    },
    ABOUT_VIDEO: {
        desc: 'סרטון - עמוד מי אנחנו',
        rule: 'https://www.youtube.com/embed/$d$',
        get: str => str.slice(str.split('/', 4).join('"').length + 1)
    },
    ROUTE_AGREEMENT: {
        desc: 'מסלולים (מוצרי סוכן)',
        rule: googleDrivePdfHelper.rule,
        get: googleDrivePdfHelper.get
    },
    HOMEPAGE_VIDEO: {
        desc: 'סרטון - דף הבית',
        rule: 'https://www.youtube.com/embed/$d$',
        get: str => str.slice(str.split('/', 4).join('"').length + 1)
    },
    SUB_AGENT_AGREEMENT_PDF: {
        desc: 'תנאי שימוש סוכן אב',
        rule: googleDrivePdfHelper.rule,
        get: googleDrivePdfHelper.get
    }
}
